import { PostMethod } from '../../serviceHelper';

const getMethods = (service: 'main', controller: 'DataSecurity') => ({
	GetSecurityDataTypes: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetSecurityDataTypes'
	}),
	CreateSecurityDataType: new PostMethod<any, any>({
		service,
		controller,
		method: 'CreateSecurityDataType'
	}),
	DeleteSecurityDataType: new PostMethod<any, any>({
		service,
		controller,
		method: 'DeleteSecurityDataType'
	}),
	UpdateSecurityDataType: new PostMethod<any, any>({
		service,
		controller,
		method: 'UpdateSecurityDataType'
	}),
	FilterData: new PostMethod<any, any>({
		service,
		controller,
		method: 'FilterData'
	})
});

export { getMethods };
